class StockValidation extends HTMLElement{
    constructor(){
        super();
    }
    connectedCallback(){
        this.validationStep = 'idle';
        this.updatePayload = {};
        this.addPayload = [];
        this.errors = [];
        this.jsonScript = this.querySelector('#CartLinesItemJson');
        const jsonData = JSON.parse(this.jsonScript.textContent);
        this.market = jsonData.market;
        this.country = jsonData.country;
        this.isSpecialOrder = jsonData.isSpecialOrder;
        this.isSplitOrder = jsonData.isSplit
        this.allowedSpecialOrderType = jsonData.allowedSpecialOrderType;
        this.strings = jsonData.strings;
        this.mapCartItems = Object.entries(jsonData.mapCartItems);
        this.continuousCartSync = jsonData.continuousCartSync;

        this.checkoutButton = document.getElementById('checkout');
        this.cartItems = document.querySelector('cart-items');
        this.cartDrawerItems = document.querySelector('cart-drawer-items');

        this.invalidCartTrigger = this.querySelector('#InvalidCartModalTrigger');
        this.invalidCartModalBody = this.querySelector('.js_invalid-cart-modal-body');
        this.invalidCartUpdateButton = this.querySelector('.js_invalid-cart-modal-update');
        this.invalidCartClearButton = this.querySelector('.js_invalid-cart-modal-clear');

        this.confirmSplitOrderTrigger = this.querySelector('#ConfirmSplittedOrderTrigger');
        this.confirmedSplitOrderButton = this.querySelector('#SplitShipmentModalConfirm');

        this.bindedCartValidation = this.cartValidation.bind(this);
        this.bindedUpdateCartButtonClickHandler = this.updateCartButtonClickHandler.bind(this);
        this.bindedClearCartButtonClickHandler = this.clearCartButtonClickHandler.bind(this);
        this.bindedConfirmSplittedOrderButtonClickHandler = this.confirmSplittedOrderButtonClickHandler.bind(this);

        this.prevMarket = sessionStorage.getItem('prev-localization');
        if (!this.prevMarket){
            sessionStorage.setItem('prev-localization',`${window.Shopify.locale}|${window.Shopify.country}|${this.market}`)
        }
        if(this.prevMarket){
            const { country, locale } = window.Shopify;
            const [prevLocale,prevCountry,prevMarket] = this.prevMarket.split('|');
            if (prevLocale !== locale || prevCountry !== country || prevMarket !== this.market){
                sessionStorage.setItem('prev-localization', `${locale}|${country}|${this.market}`);
            }
            if(this.mapCartItems.length > 0){
                if (prevMarket !== this.market){
                    this.cartValidation('sync');
                }
            }
        }

        if(this.continuousCartSync?.keysNeedPropUpdate?.length > 0 && this.continuousCartSync?.propValuesUpdated){
            if(this.validationStep !== 'updating'){
                this.updatePreOrderProps();
            }
        }

        if(this.checkoutButton){
            if(this.validationStep !== 'updating'){
                this.checkoutButton.disabled = false;
            }
            this.checkoutButton.addEventListener('click',this.bindedCartValidation)
        }

        if(this.invalidCartUpdateButton)
            this.invalidCartUpdateButton.addEventListener('click',this.bindedUpdateCartButtonClickHandler)
        if(this.invalidCartClearButton)
            this.invalidCartClearButton.addEventListener('click',this.bindedClearCartButtonClickHandler)
        if(this.confirmedSplitOrderButton)
            this.confirmedSplitOrderButton.addEventListener('click',this.bindedConfirmSplittedOrderButtonClickHandler)

    }
    disconnectedCallback(){
        if (this.validationStep === 'updated'){
            document.getElementById('StockValidationComponent')?.continueCheckoutFlow(this.validationStep);
        }
    }

    async updatePreOrderProps(){
        const keysNeedPropUpdate = this.continuousCartSync?.keysNeedPropUpdate;
        const propValuesUpdated = this.continuousCartSync?.propValuesUpdated;

        let jsIndex = 0;
        for (const line of keysNeedPropUpdate) {
            try{
                const response = await fetch(`${routes.cart_change_url}.js`,{
                    method:'POST',
                    headers:{'Content-Type': 'application/json'},
                    body:JSON.stringify({
                        "id":line.key,
                        "quantity": line.quantity,
                        "properties":{
                            ...line.properties,
                            "Pre-order": propValuesUpdated[jsIndex]
                        }
                    })
                })
            }
            catch(error){
                console.error('While: Update line item props',error);
            }
            finally {
                jsIndex++;
            }
        }
        if(this.cartItems) this.cartItems.onCartUpdate();
        if(this.cartDrawerItems) this.cartDrawerItems.onCartUpdate();
    }

    cartValidation(event = null){
        this.validationStep = 'checking';
        let keepingCartSync = false;
        if (event) {
            if (typeof event === 'string'){
                keepingCartSync = true;
            } else
                event.preventDefault();
        }
        let lineErrors = [];
        let updatePayload = {};
        let addPayload = [];
        let REMOVE_SPECIAL_PARTIAL = 0;
        let REMOVE_SPECIAL_TOTAL = 0;
        let INCREASE_SPECIAL = 0;
        let INCREASE_SPECIAL_UNAVAILABLE = 0;
        let REMOVE_SPECIAL_PARTIAL_UNAVAILABLE = 0;
        let SPECIAL_UNAVAILABLE = 0;
        let OK = 0;
        for( const [productGid, item] of this.mapCartItems){
            let orderValid;
            if(this.market !== 'asia') orderValid = this.validateOrder(item.normalQuantity,item.specialQuantity,item.stockEu,item.preOrderQuantity);
            // Disable Cross Order
            else if(this.country === 'HK' || this.country === 'MO') orderValid = this.validateOrder(item.normalQuantity,item.specialQuantity,item.stockHk,item.stockEu);
            else orderValid = this.validateOrder(item.normalQuantity,item.specialQuantity,item.stockHk,0);
            if(orderValid.status !== 'OK'){
                this.validationStep = 'invalid'
                const normalLine = item.cartLines.find(line => !line.specialOrder);
                const specialLine = item.cartLines.find(line => line.specialOrder);

                if (orderValid.status === 'REMOVE_SPECIAL_PARTIAL'){
                    REMOVE_SPECIAL_PARTIAL++
                    const { update, addItem, lineError} = this.handleRemoveSpecial(specialLine,normalLine,orderValid.reduceBy,item);
                    Object.assign(updatePayload, update);
                    addPayload.push(addItem);
                    lineErrors.push(...lineError);
                }
                if (orderValid.status === 'REMOVE_SPECIAL_TOTAL'){
                    REMOVE_SPECIAL_TOTAL++;
                    const { update, addItem, lineError} = this.handleRemoveSpecial(specialLine,normalLine,specialLine.quantity,item);
                    Object.assign(updatePayload, update);
                    addPayload.push(addItem);
                    lineErrors.push(...lineError);
                }
                if (orderValid.status === 'INCREASE_SPECIAL'){
                    debugger;
                    INCREASE_SPECIAL++;
                    const { update, addItem, lineError} = this.handleIncreaseSpecial(specialLine,normalLine,orderValid.increaseBy,item);
                    Object.assign(updatePayload, update);
                    addPayload.push(addItem);
                    lineErrors.push(...lineError);
                }
                if (orderValid.status === 'INCREASE_SPECIAL_UNAVAILABLE'){
                    INCREASE_SPECIAL_UNAVAILABLE++;
                    const { update, addItem, lineError} = this.handleIncreaseSpecialError(
                        specialLine,
                        normalLine,
                        orderValid.decreaseBy,
                        orderValid.increaseBy,
                        orderValid.unavailable,
                        item
                    );
                    Object.assign(updatePayload, update);
                    if (addItem) addPayload.push(addItem);
                    lineErrors.push(...lineError);
                }
                if (orderValid.status === 'REMOVE_SPECIAL_PARTIAL_UNAVAILABLE'){
                    REMOVE_SPECIAL_PARTIAL_UNAVAILABLE++;
                    const { update, addItem, lineError} = this.handleRemoveSpecialError(
                        specialLine,
                        normalLine,
                        orderValid.increaseBy,
                        orderValid.decreaseBy,
                        orderValid.unavailable,
                        item
                    )
                    Object.assign(updatePayload, update);
                    addPayload.push(addItem);
                    lineErrors.push(...lineError);
                }
                if (orderValid.status === 'SPECIAL_UNAVAILABLE'){
                    SPECIAL_UNAVAILABLE++;
                    const { update, lineError} = this.handleSpecialUnavailable(
                        specialLine,
                        normalLine,
                        orderValid.decreaseBy,
                        orderValid.unavailable,
                        item
                    );
                    Object.assign(updatePayload, update);
                    lineErrors.push(...lineError);
                }
            } else OK++;
        }

        this.updatePayload = updatePayload;
        this.addPayload = addPayload;
        if (keepingCartSync){
            this.updateCart();
            return;
        }
        else {

            if (lineErrors.length > 0){
                this.errors = lineErrors.filter(line => line?.key && line.key !== null);
                const html = lineErrors.map(line => this.modalInvalidCartMarkup(line)).join('\n');
                this.invalidCartModalBody.innerHTML = html;
                this.invalidCartTrigger.click();
            }
            else{
                this.validationStep = 'validated';
                if (this.isSpecialOrder &&
                    (this.country === 'HK' || this.country === 'MO') &&
                    this.isSplitOrder
                ) this.confirmSplitOrderTrigger.click();
                else if (this.isSpecialOrder &&
                        (this.country !== 'HK' && this.country !== 'MO')) this.confirmSplitOrderTrigger.click();
                else {
                    fetch(`${routes.cart_update_url}.js`,{
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body:JSON.stringify({
                            attributes:{
                                "isSplitted":false,
                                "_createdOnCountry": this.country,
                                "_createdOnMarket":this.market,
                                "_cartUrl":routes.cart_url
                            }
                        })
                    })
                        .then(res => {
                            window.location.href = `${Shopify.routes.root}checkout`;
                        })
                }
            }
        }
    }

    async updateCart(){
        this.validationStep = 'updating';

        if(this.checkoutButton) this.checkoutButton.disabled = true;

        try{
            if (Object.keys(this.updatePayload).length > 0){
                const updateResponse = await fetch(`${routes.cart_update_url}.js`,{
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        updates: this.updatePayload
                    })
                })
            }
            if (this.addPayload.length > 0){
                const addResponse = await fetch(`${routes.cart_add_url}.js`,{
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items:[...this.addPayload]
                    })
                })
            }
            if(this.checkoutButton) this.checkoutButton.disabled = false;
            if(this.cartItems)
                this.cartItems.onCartUpdate();
            if(this.cartDrawerItems)
                this.cartDrawerItems.onCartUpdate();

        }
        catch(error){
            console.error(error);
            this.toggleLoadingState(event.target);
        }
    }
    async updateCartButtonClickHandler(event){
        this.toggleLoadingState(event.target);
        this.validationStep = 'updating';
        try{
            if (Object.keys(this.updatePayload).length > 0){
                const updateResponse = await fetch(`${routes.cart_update_url}.js`,{
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        updates: this.updatePayload
                    })
                })
            }
            if (this.addPayload.length > 0){
                const addResponse = await fetch(`${routes.cart_add_url}.js`,{
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items:[...this.addPayload]
                    })
                })
            }

            this.validationStep = 'updated';
            this.toggleLoadingState(event.target);
            this.invalidCartTrigger.click();
            this.cartItems.onCartUpdate();
        }
        catch(error){
            console.error(error);
            this.toggleLoadingState(event.target);
        }
    }
    async clearCartButtonClickHandler(event){
        this.toggleLoadingState(event.target);
        this.validationStep = 'updating';
        const payload = this.errors.reduce((acc, item) => {
            acc[item.key] = 0;
            return acc;
        }, {});
        try {
            const clearResponse = await fetch(`${routes.cart_update_url}.js`,{
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    updates:payload
                })
            });
            this.validationStep = 'cleared';
            this.toggleLoadingState(event.target);
            this.invalidCartTrigger.click();
            this.cartItems.onCartUpdate();
        }
        catch(error){
            console.error('while clear',error);
        }
    }
    async confirmSplittedOrderButtonClickHandler(event){
        this.toggleLoadingState(event.target);
        let isSplitted = false;
        if (this.market === 'asia' && (this.country === 'HK' || this.country === 'MO')) isSplitted = true
        try{
            const updateResponse = await fetch(`${routes.cart_update_url}.js`,{
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body:JSON.stringify({
                    attributes:{
                        "isSplitted":isSplitted,
                        "_createdOnCountry": this.country,
                        "_createdOnMarket":this.market,
                        "_cartUrl":routes.cart_url,
                    }
                })
            })
            this.toggleLoadingState(event.target);
            window.location.href = `${Shopify.routes.root}checkout`;
        }
        catch(error){
            console.error('cart attribute update error',error)
        }
    }
    handleRemoveSpecial(specialLine,normalLine,reduceBy,item){
        const title = specialLine.title;
        const img = specialLine.image;
        const addedNormalQuantity = reduceBy !== 0 ? reduceBy : specialLine.quantity;
        const update = {};
        const lineError = [];
        update[specialLine.key] = reduceBy === 0 ? 0 : specialLine.quantity - reduceBy;
        const addItem = {
            id: specialLine.variantId,
            quantity: addedNormalQuantity
        };
        // Line error for special line
        lineError.push({
            title,
            img,
            oldQuantity: specialLine.quantity,
            newQuantity: specialLine.quantity - reduceBy,
            attribute:specialLine.attribute,
            key:specialLine.key
        });
        // Line error for normal line
        lineError.push({
            title,
            img,
            oldQuantity: normalLine ? normalLine.quantity : 0,
            newQuantity: normalLine ? normalLine.quantity + addedNormalQuantity : addedNormalQuantity,
            attribute:normalLine ? normalLine.attribute : {},
            key:normalLine ? normalLine.key : null
        })
        return {update, addItem, lineError};
    }
    handleIncreaseSpecial(specialLine,normalLine,increaseBy,item){
        const title = normalLine.title;
        const img = normalLine.image;
        let attribute = {};
        switch(this.allowedSpecialOrderType){
            case 'crossorder':{
                attribute = { "Shipping in": '20 days' }
                break;
            }
            case 'preorder':{
                let attributeValue = item.cartLines.find(el => el.hasOwnProperty('preOrderDate'))
                attribute = { "Pre-order": attributeValue.preOrderDate }
                break;
            }
            default: {
                break;
            }
        }
        const update = {};
        const lineError = [];
        if (normalLine){
            update[normalLine.key] = normalLine.quantity - increaseBy;
            lineError.push({
                title,
                img,
                oldQuantity: normalLine.quantity,
                newQuantity: normalLine.quantity - increaseBy,
                attribute:normalLine.attribute,
                key:normalLine.key
            })
        }
        const addItem = {
            id: normalLine ? normalLine.variantId : specialLine.variantId,
            quantity: increaseBy,
            properties: specialLine ? specialLine.attribute : attribute
        };
        lineError.push({
            title,
            img,
            oldQuantity: specialLine ? specialLine.quantity : 0,
            newQuantity: specialLine ? specialLine.quantity + increaseBy : increaseBy,
            attribute: specialLine ? specialLine.attribute : attribute,
            key: specialLine ? specialLine.key : null
        })

        return {update, addItem, lineError};
    }
    handleRemoveSpecialError(specialLine,normalLine,increaseBy,reduceBy,unavailable,item){
        const title = specialLine.title;
        const img = specialLine.image;
        // const addedNormalQuantity = reduceBy !== 0 ? reduceBy : specialLine.quantity;
        const update = {};
        const lineError = [];
        update[specialLine.key] = reduceBy === 0 ? 0 : specialLine.quantity - reduceBy;
        const addItem = {
            id: specialLine.variantId,
            quantity: increaseBy
        };
        // Line error for special line
        lineError.push({
            title,
            img,
            oldQuantity: specialLine.quantity,
            newQuantity: specialLine.quantity - reduceBy,
            attribute:specialLine.attribute,
            unavailable: specialLine.quantity - reduceBy,
            key: specialLine.key
        });
        // Line error for normal line
        lineError.push({
            title,
            img,
            oldQuantity: normalLine ? normalLine.quantity : 0,
            newQuantity: normalLine ? normalLine.quantity + increaseBy : increaseBy,
            attribute:normalLine ? normalLine.attribute : {},
            key: normalLine ? normalLine.key : null
        })
        return {update, addItem, lineError};
    }
    handleIncreaseSpecialError(specialLine, normalLine, decreaseBy, increaseBy, unavailable, item){
        const title = normalLine.title;
        const img = normalLine.image;
        let attribute = {};
        switch(this.allowedSpecialOrderType){
            case 'crossorder':{
                attribute = { "Shipping in": '20 days' }
                break;
            }
            case 'preorder':{
                let attributeValue = item.cartLines.find(el => el.hasOwnProperty('preOrderDate'))
                attribute = { "Pre-order": attributeValue.preOrderDate }
                break;
            }
            default: {
                break;
            }
        }
        const update = {};
        const lineError = [];
        let addItem = null;
        if (normalLine){
            update[normalLine.key] = normalLine.quantity - decreaseBy;
            lineError.push({
                title,
                img,
                oldQuantity: normalLine.quantity,
                newQuantity: normalLine.quantity - decreaseBy,
                attribute:normalLine.attribute,
                unavailable: normalLine.quantity - decreaseBy,
                key: normalLine.key
            })
        }
        const newQuantity = specialLine ? specialLine.quantity + increaseBy : increaseBy;
        const oldQuantity = specialLine ? specialLine.quantity : 0;
        if (newQuantity > oldQuantity){
            addItem = {
                id: normalLine ? normalLine.variantId : specialLine.variantId,
                quantity: increaseBy,
                properties: specialLine ? specialLine.attribute : attribute
            };
            lineError.push({
                title,
                img,
                oldQuantity,
                newQuantity,
                attribute: specialLine ? specialLine.attribute : attribute,
                unavailable: newQuantity,
                key: specialLine ? specialLine.key : null
            })
        }
        else if (newQuantity < oldQuantity && specialLine){
            update[specialLine.key] = newQuantity;
            lineError.push({
                title,
                img,
                oldQuantity,
                newQuantity,
                attribute: specialLine.attribute,
                unavailable: newQuantity,
                key: specialLine.key
            })
        }
        return {update, addItem, lineError};
    }
    handleSpecialUnavailable(specialLine,normalLine,decreaseBy,unavailable,item){
        const title = specialLine.title;
        const img = specialLine.image;
        const update = {};
        const lineError = [];
        update[specialLine.key] = Math.max(specialLine.quantity - decreaseBy,0);
        lineError.push({
            title,
            img,
            oldQuantity: specialLine.quantity,
            newQuantity: specialLine.quantity - decreaseBy,
            attribute:specialLine.attribute,
            unavailable: specialLine.quantity - decreaseBy,
            key:specialLine.key
        });
        return { update, lineError}
    }
    modalInvalidCartMarkup(line){
        const attribute = Object.entries(line.attribute).map(([key, value]) => {
            return `<p style="font-style:italic;font-size:13px"><span class="fw-bold">${key}:</span> <span>${value}</span></p>`;
        }).join('\n');
        return `
            <div class="d-flex align-items-center mb-3">
              <div class="cart-item__media">
                  <div class="cart-item__image-container">
                    <img class="cart-item__image" src="${line.img ? line.img : window.ShopifyStorefront.utils.noImage}" alt="${line.title}" height="100" width="75">
                  </div>
              </div>

              <div style="margin-left:10px;flex:0 0 75%">
                <p class="cart-item__name h4 break" style="font-family:Inter;${line.newQuantity === 0 ? 'text-decoration:line-through;' : ''}">${line.title}</p>
                ${attribute}
                ${line?.unavailable === undefined
                    ? ''
                    : line.unavailable !== 0
                        ? `
                          <p class="text-danger small-p">${this.strings.cartQuantityError.replace('[quantity]',line.unavailable)}</p>
                        `
                        : `
                          <p class="text-danger small-p">${this.strings.addToCartError.replace('[product_name]',line.title)}</p>
                        `
                }
              </div>
              <div class="ms-auto" style="min-width:fit-content;">
                <p style="text-decoration:none;">
                  <span class="text-danger">${line.oldQuantity}</span>
                  <span>&rarr;</span>
                  <span class="text-success">${line.newQuantity}</span>
                </p>
              </div>
            </div>
        `;
    }
    continueCheckoutFlow(step){
        this.validationStep = step;
        this.cartValidation();
    }
    toggleLoadingState(target){
        const parent = target.parentElement;
        const buttons = parent.querySelectorAll('button');

        target.classList.toggle('loading');
        target.querySelector('.loading__spinner')?.classList.toggle('hidden');

        if (!buttons.length) return;
        buttons.forEach(button => {
            button.disabled = !button.disabled;
        })

    }
    validateOrder(normalQty,specialQty,normalStock,specialStock){
        // Check that all quantities are >= 0
        if (normalQty < 0 || specialQty < 0 || normalStock < 0 || specialStock < 0) {
            return { status: "ERROR", reason: "All quantities must be >= 0" };
        }

        // We don't have enough normal stock, so we try to increase specialQty
        if (normalQty > normalStock) {
            const excessNormal = normalQty - normalStock;
            if (specialQty + excessNormal <= specialStock) {
                return { status: "INCREASE_SPECIAL", increaseBy: excessNormal };
            } else {
                // We don't have enough special stock to increase the special quantity, we have some quanties out of stock
                const unavailable = (specialQty + excessNormal) - specialStock;
                const increaseBy = excessNormal - unavailable;
                return {
                    status: "INCREASE_SPECIAL_UNAVAILABLE",
                    decreaseBy: excessNormal,
                    increaseBy,
                    unavailable,
                    reason: `Normal quantity (${normalQty}) exceeds normal stock (${normalStock}) and cannot be fully shifted to special quantity. Required: ${specialQty + excessNormal}, Available: ${specialStock}`,
                };
            }
        }

        // We may be able to reduce the special quantity ordered, a move as normal quantity
        const normalStockSurplus = normalStock - normalQty;
        const specialCoveredByNormalStock = Math.min(specialQty, normalStockSurplus);
        const specialRemainingToFulfill = specialQty - specialCoveredByNormalStock;

        // We have enough normal stocks, we don't need special order
        if (normalStockSurplus >= specialQty && specialQty > 0) {
            return { status: "REMOVE_SPECIAL_TOTAL" };
        }

        // We have some normal stock available to reduce special quantity
        if (specialCoveredByNormalStock > 0) {
            // In this case, even after decreasing special quantity ordered, we still don't have enough special stock to fulfill the order. We have some quantity out of stock
            if (specialRemainingToFulfill > specialStock) {
                return {
                    status: "REMOVE_SPECIAL_PARTIAL_UNAVAILABLE",
                    increaseBy:specialCoveredByNormalStock,
                    decreaseBy: specialQty - specialStock,
                    unavailable: specialRemainingToFulfill - specialStock,
                };
            }
            // Here we don't have out of stock
            return { status: "REMOVE_SPECIAL_PARTIAL", reduceBy: specialCoveredByNormalStock };
        }

        // This happens when normalQuantity === normalStock, if we arrive here, we last check if the special order is fulfillable
        if (specialQty > specialStock) {
            return {
                status: "SPECIAL_UNAVAILABLE",
                decreaseBy:specialQty - specialStock,
                unavailable: specialQty - specialStock,
            };
        }

        return { status: "OK" };
    }
}
if (!customElements.get('stock-validation')) {
    customElements.define('stock-validation', StockValidation);
}




